module.exports = __webpack_public_path__ + "static/media/36x36-1.9d379520.png";